import gql from 'graphql-tag';

export const createVisitorWatchlistMutation = gql(/* GraphQL */ `
  mutation createVisitorWatchlist($input: VisitorWatchlistCreateInput!) {
    createVisitorWatchlist(input: $input) {
      visitorWatchlist {
        id
        organizationId
        severityLevel
        notes
        reportedBy
        createdBy
        updatedBy
        createdAt
        updatedAt
        tenantIds
        visitorMatchingInfo {
          firstName {
            primaryValue
            alternateValues
            matchType
          }
          lastName {
            primaryValue
            alternateValues
            matchType
          }
          email {
            primaryValue
            alternateValues
            matchType
          }
          phone {
            primaryValue
            alternateValues
            matchType
          }
        }
      }
    }
  }
`);
